import { useTranslation } from "react-i18next";
import type { SchemaRegion } from "../../../api/restaurantSchema";
import { PlusIcon } from "../../../components/restaurant-schema/schemaIcons";
import RegionSegmentedTabs from "../../../components/restaurant-schema/RegionSegmentedTabs";

/**
 * „+ Нов регион" — пунктирен бутон, 42px като табовете. На телефон слиза на
 * реда под табовете (горният ред е само за тях), затова е отделен компонент.
 */
export const NewRegionButton = ({ onClick, className = "" }: { onClick: () => void; className?: string }) => {
  const { t } = useTranslation();
  return (
    <button
      type="button"
      onClick={onClick}
      className={`flex h-[42px] shrink-0 cursor-pointer items-center justify-center gap-1.5 whitespace-nowrap rounded-[10px] border border-dashed border-shade-4 bg-transparent px-3.5 text-[13.5px] font-semibold text-body transition-colors duration-150 hover:bg-surface ${className}`}
    >
      <PlusIcon className="h-[15px] w-[15px]" />
      {t("restaurantSchema.regionTabs.newRegion")}
    </button>
  );
};

/**
 * Табовете на регионите — общият сегментиран контрол (`RegionSegmentedTabs`,
 * същият като в „Конфигурация на маси"), „Нов регион" закачен вдясно, извън
 * скрола — винаги видим. Без `onCreate` бутонът не се рендира (на телефон
 * страницата го слага на реда отдолу).
 */
const RegionTabs = ({
  regions,
  activeId,
  onChange,
  onCreate,
}: {
  regions: SchemaRegion[];
  activeId: number | null;
  onChange: (regionId: number) => void;
  onCreate?: () => void;
}) => (
  <div className="flex min-w-0 items-center gap-2">
    <RegionSegmentedTabs regions={regions} activeId={activeId} onChange={onChange} />
    {onCreate && <NewRegionButton onClick={onCreate} />}
  </div>
);

export default RegionTabs;
